import { render, staticRenderFns } from "./BaseHeader.vue?vue&type=template&id=33968b6c&scoped=true"
import script from "./BaseHeader.vue?vue&type=script&lang=js"
export * from "./BaseHeader.vue?vue&type=script&lang=js"
import style0 from "./BaseHeader.vue?vue&type=style&index=0&id=33968b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33968b6c",
  null
  
)

export default component.exports